import React from 'react';
import './home.css'
import '../../App.css'
import Sec5Slider from './Sec5Slider.js';
import Sec5SliderReal from './Sec5SliderReal.js';
import Sec4ArrowSvg from '../../svgs/home/Sec4ArrowSvg.js'
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../hook/UseLang.js';
import CONTENT from '../../contents/home.js'
import BTN from '../../contents/btn.js'
import { useCallback } from 'react';
  const Home3 = () => {
    const navigate = useNavigate()
    const [lang, setLang] = useLang()
    const Sliders = useCallback(() => <Sec5SliderReal />,[])
    
    return (
        <div className='w-full relative min-h-[97vh]-custom'>
            <img src='./images/bg_texture.jpg' className='absolute top-0 left-0 w-full h-full' style={{objectFit: 'cover', zIndex:1}}></img>
            <div className='absolute top-0 left-0 w-full h-full bg-[#ffffff] opacity-[0.7]' style={{zIndex:2}}></div>
            <div className='relative w-full h-full flex flex-col items-center justify-center' style={{zIndex:3}}>
                <div className='w-full pt-[91px] relative' style={{overflowY:'visible'}}>
                    {/* <Sec5Slider /> */}
                    <Sliders />
                </div>
                <div onClick={() => navigate(`/news?lang=${lang}`)} className='two-k-hidden btn-arrow mt-[48px] text-d-12 px-[88px] py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300'>
                    <div className=''>{BTN.view_more[lang]}</div>
                    <div className='absolute right-[-14%] top-[46%] arrow-moveleft'>
                        <Sec4ArrowSvg/>
                    </div>
                </div>
            </div>
            <div onClick={() => navigate(`/news?lang=${lang}`)} className='two-k-show relative max-w-[500px] bottom-[10%] left-[44%] btn-arrow text-d-12 flex flex-row items-center justify-center py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300' style={{zIndex:99}}>
                <div className=''>{BTN.view_more[lang]}</div>
                <div className='absolute right-[-14%] top-[46%] arrow-moveleft'>
                    <Sec4ArrowSvg/>
                </div>
            </div>
        </div>
    );
};

export default Home3;

                    